import { useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../config";

let pinged = false; // ping once per session

export function useServerWarmup() {
  useEffect(() => {
    if (pinged) return;
    pinged = true;
    axios.get(`${API_BASE_URL}/ping`, { timeout: 90000 }).catch(() => {
      // Silently ignore — just waking the server up
    });
  }, []);
}
